import { Fragment, useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import { useHistory } from 'react-router';
import { components } from "react-select";
import makeAnimated from "react-select/animated";
import BulletinList from './BulletinList';
import DisplayBulletinSelect from './DisplayBulletinSelect';

const Option = props => {
    return (
        <div>
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                />{" "}
                <label>{props.label}</label>
                {/* <label className='label-container'>{props.label}
                    <input
                        type="checkbox"
                        checked={props.isSelected}
                        onChange={() => null}
                    />{" "}
                    <span className='checkmark'></span>
                </label> */}
            </components.Option>
        </div>
    );
};

const allOption = {
    label: "Select all",
    value: "*"
};

const ValueContainer = ({ children, ...props }) => {
    const currentValues = props.getValue();
    let toBeRendered = children;
    if (currentValues.some(val => val.value === allOption.value)) {
        toBeRendered = [[children[0][0]], children[1]];
    }

    return (
        <components.ValueContainer {...props}>
            {toBeRendered}
        </components.ValueContainer>
    );
};

const MultiValue = props => {
    let labelToBeDisplayed = `${props.data.label} `;
    if (props.data.value === allOption.value) {
        labelToBeDisplayed = "Selected all";
    }
    return (
        <components.MultiValue {...props}>
            <span>{labelToBeDisplayed}</span>
        </components.MultiValue>
    );
};

const customStyles = {
    control: styles => ({ 
        ...styles, 
        padding: '3px',
        borderRadius: '50px', 
        boxShadow: '0px 5px 15px 0px rgb(0 0 0 / 20%)',
    }),
    option: (provided, state) => ({ 
        ...provided,
        '&:hover': {
            backgroundColor: '#dfe3f1'
        },
        backgroundColor: state.isSelected && '#dfe3f1',
        color: 'black'
    }),
};

const animatedComponents = makeAnimated();

const Bulletins = ({ bulletins, onDelete, badgeID, loginList }) => {
    const [permit, setPermit] = useState(false)
    const [searchTerm, setSearchTerm] = useState('')
    const [pageNumber, setPageNumber] = useState(0)

    const [optionSelected, setOptionSelected] = useState([])

    useEffect(() => {
        if (loginList) {
            const loginListFromParent = loginList;

            const permit = loginListFromParent.some((item) =>
                (item.permissionName.includes("Admin Role") && item.permissionType.includes("edit")) 
                || 
                (item.permissionName.includes("Bulletin Board") && item.permissionType.includes("edit"))
            )

            if (permit) {
                setPermit(true)
            }
        }
    }, [loginList])

    const bulletinsPerPage = 9
    const pagesVisited = pageNumber * bulletinsPerPage
    const pageCount = Math.ceil(
        bulletins.filter((bulletin) => {
            if (searchTerm === "") {
            return bulletin;
        } else if (
            bulletin.title.toLowerCase().includes(searchTerm.toLowerCase())
        ) {
            return bulletin;
        }
            return false;
        }).length / bulletinsPerPage
    );

    const handlePageChange = ({ selected }) => {
        setPageNumber(selected)
    }

    const displayBulletins = bulletins
    .sort((a, b) => 'lse'.indexOf(a.liveStatus[0]) - 'lse'.indexOf(b.liveStatus[0]))
    .filter((bulletin) => {
        if (optionSelected.length === 0) { // to return all bulletins when no options are selected
            return true;
        } else {
            return optionSelected
            .map((item) => item.value)
            .includes(bulletin.liveStatus.toLowerCase())
        }
    })
    .filter((bulletin) => {
        if (searchTerm === '') {
            return bulletin
        } else if (bulletin.title.toLowerCase().includes(searchTerm.toLowerCase())) {
            return bulletin
        }
        return false
    })
    .slice(pagesVisited, pagesVisited + bulletinsPerPage)
    .map((bulletin) => {
        return (
            <Fragment key={bulletin.bbID}>
                <BulletinList
                    bulletin={bulletin}
                    onDelete={onDelete}
                    badgeID={badgeID}
                    loginList={loginList}
                />
            </Fragment>
        );
    })

    const displayOptions = [
        { value: "live", label: "Live" },
        { value: "schedule", label: "Schedule" },
        { value: "end", label: "End"}
    ];

    const handleChange = selected => {
        setOptionSelected(selected)
    };

    const history = useHistory();

    const createBulletinBtn = () => {
        history.push('/bulletinboard/create')
    }

    return (
        <Fragment>
            <div className='search-wrapper'>
                {permit ?
                    <div className='btn btn-primary' onClick={createBulletinBtn} style={{marginBottom: '20px'}}>
                        Create New
                    </div>
                    :
                    <Button variant='primary' disabled style={{visibility: 'hidden', marginBottom: '20px'}}>
                        Create New
                    </Button>
                }
                <div style={{display: 'flex'}}>
                    <label htmlFor='search-form' style={{marginRight: '5px'}}>
                        <input
                            type='search' 
                            className='search-input' 
                            placeholder=' Search'
                            style={{
                                borderRadius: '50px',
                                marginTop: '11px',
                                padding: '10px 5px 7px 12px',
                                boxShadow: '0px 5px 15px 0px rgb(0 0 0 / 20%)'
                            }}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                handlePageChange({ selected: 0 });
                            }}
                        />
                    </label>
                    <div style={{width: '15rem', marginTop: '10px'}}>
                        <DisplayBulletinSelect
                            options={displayOptions}
                            isMulti
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            components={{
                                Option,
                                MultiValue,
                                ValueContainer,
                                animatedComponents
                            }}
                            styles={customStyles}
                            onChange={handleChange}
                            allowSelectAll={true}
                            value={optionSelected}
                        />
                    </div>
                </div>
            </div>
            <Row xs={1} md={3} className='g-3'>
                {displayBulletins}
            </Row>
            <Row>
                <Col className='bulletinPagination' md={12}>
                    <ReactPaginate 
                        previousLabel={'<'}
                        nextLabel={'>'}
                        pageCount={pageCount}
                        onPageChange={handlePageChange}
                        forcePage={pageNumber}
                        breakClassName={'page-item'}
                        breakLinkClassName={'page-link'}
                        containerClassName={'pagination'}
                        pageClassName={'page-item'}
                        pageLinkClassName={'page-link'}
                        previousClassName={'page-item'}
                        previousLinkClassName={'page-link'}
                        nextClassName={'page-item'}
                        nextLinkClassName={'page-link'}
                        activeClassName={'active'}
                    />
                </Col>
            </Row>
        </Fragment>
    );
};

export default Bulletins;
